import { Skeleton, VStack } from '@chakra-ui/react';
import _ from 'lodash';

export interface SkeletonLoaderProps {
  rowCount?: number;
}

export const SkeletonLoader = ({ rowCount = 5 }: SkeletonLoaderProps) => {
  return (
    <VStack alignItems="start" data-testid="chat-gpt-skeleton-loader">
      {_.range(rowCount).map((_x, index) => (
        <Skeleton
          data-testid="chat-gpt-skeleton-loader-row"
          w={`calc(100% - ${_.random(0, 99)}%)`}
          key={index}
          borderRadius="0px"
          height="16px"
        />
      ))}
    </VStack>
  );
};
